import Danger from './colors/Danger';
import Mauve from './colors/Mauve';
import Insightful from './colors/Insightful';
import Neutral from './colors/Neutral';
import Primary from './colors/Primary';
import Royal from './colors/Royal';
import Success from './colors/Success';
import Warning from './colors/Warning';

const ColourPalette = {
  palette: {
    ...Danger,
    ...Insightful,
    ...Mauve,
    ...Neutral,
    ...Primary,
    ...Royal,
    ...Success,
    ...Warning,
  },
};

export default ColourPalette;
